import React from "react";
import { Trans } from "react-i18next";

import { Callout, Card, CardList, Radio, Tag } from "@blueprintjs/core";
import {
  authenticatedGetFetch,
  authenticatedPostFetch,
} from "../../../utils/AuthenticatedFetch";
import { mefPlate } from "../../../utils/mef";
import { Equals } from "@blueprintjs/icons";

export default function Tolerance(props) {
  const [tolerance, setTolerance] = React.useState(0);

  function update() {
    authenticatedGetFetch("/ow/dc/settings/tolerance?srv=" + props.srv, (res) => {
      setTolerance(res);
    });
  }

  React.useEffect(() => {
    update();
  }, []);

  return (
    <Callout title={<Trans>matching tolerance</Trans>}>
      <CardList>
        {[0, 1, 2, 3, 4].map((level) => (
          <Card
            key={"tolevel" + level}
            interactive={true}
            selected={tolerance === level}
            onClick={() =>
              authenticatedPostFetch("/ow/dc/settings/tolerance?srv=" + props.srv, level, () =>
                update()
              )
            }
          >
            <Radio checked={tolerance === level} readOnly={true} />
            <Trans>{"tolerance_level_" + level}</Trans>
          </Card>
        ))}
      </CardList>
      <Callout intent="primary" title="examples">
        {/* level 0: exect matching */}
        <Callout intent={tolerance >= 0 ? "success" : "danger"}>
          <Tag icon="blank" className="licenseplate-little">
            {mefPlate("AB123CD")}
          </Tag>
          <Equals />
          <Tag icon="blank" className="licenseplate-little">
            {mefPlate("AB123CD")}
          </Tag>
        </Callout>

        {/* level 1: 1 similar char */}
        <Callout intent={tolerance >= 1 ? "success" : "danger"}>
          <Tag icon="blank" className="licenseplate-little">
            {mefPlate("AB123CD")}
          </Tag>
          <Equals />
          <Tag icon="blank" className="licenseplate-little">
            {mefPlate("ABI23CD")}
          </Tag>
        </Callout>

        {/* level 2: 1 char */}
        <Callout intent={tolerance >= 2 ? "success" : "danger"}>
          <Tag icon="blank" className="licenseplate-little">
            {mefPlate("AB123CD")}
          </Tag>
          <Equals />
          <Tag icon="blank" className="licenseplate-little">
            {mefPlate("AB123C")}
          </Tag>
        </Callout>
        <Callout intent={tolerance >= 2 ? "success" : "danger"}>
          <Tag icon="blank" className="licenseplate-little">
            {mefPlate("AB123CD")}
          </Tag>
          <Equals />
          <Tag icon="blank" className="licenseplate-little">
            {mefPlate("AB123CX")}
          </Tag>
        </Callout>

        {/* level 3: 1 similar + 1 char */}
        <Callout intent={tolerance >= 3 ? "success" : "danger"}>
          <Tag icon="blank" className="licenseplate-little">
            {mefPlate("AB123CD")}
          </Tag>
          <Equals />
          <Tag icon="blank" className="licenseplate-little">
            {mefPlate("ABI23C")}
          </Tag>
        </Callout>
        <Callout intent={tolerance >= 3 ? "success" : "danger"}>
          <Tag icon="blank" className="licenseplate-little">
            {mefPlate("AB123CD")}
          </Tag>
          <Equals />
          <Tag icon="blank" className="licenseplate-little">
            {mefPlate("ABI23CX")}
          </Tag>
        </Callout>

        {/* level 4: 2 char */}
        <Callout intent={tolerance >= 4 ? "success" : "danger"}>
          <Tag icon="blank" className="licenseplate-little">
            {mefPlate("AB123CD")}
          </Tag>
          <Equals />
          <Tag icon="blank" className="licenseplate-little">
            {mefPlate("AB123")}
          </Tag>
        </Callout>
        <Callout intent={tolerance >= 4 ? "success" : "danger"}>
          <Tag icon="blank" className="licenseplate-little">
            {mefPlate("AB123CD")}
          </Tag>
          <Equals />
          <Tag icon="blank" className="licenseplate-little">
            {mefPlate("AB123XX")}
          </Tag>
        </Callout>
        <Callout intent={tolerance >= 4 ? "success" : "danger"}>
          <Tag icon="blank" className="licenseplate-little">
            {mefPlate("AB123CD")}
          </Tag>
          <Equals />
          <Tag icon="blank" className="licenseplate-little">
            {mefPlate("AX123XD")}
          </Tag>
        </Callout>
      </Callout>
    </Callout>
  );
}
